<template>
  <!-- 7 Aug 2026 JCH: NC-1620 — keep attachments visible when readonlyType (inbound email/fax/web in); edit controls stay gated below -->
  <div class="pb-0 mb-0">
    <!-- 10 Oct 2025 JCH attachment count and scroll hint -->
    <div class="caption grey--text px-4 mt-2 d-flex align-center">
      <v-icon small class="mr-0" style="margin-left: 4px">mdi-paperclip</v-icon>
      <button-tip btnclass="mr-2" btnstyle="margin-left: 2px" icon iname="mdi-refresh" tip="Refresh attachments" @click="getAllFiles(fid, typeId)" xsmall/>
      {{ filesArray.filter(f => groups.includes('admin') || !(f.file_type === 1 || f.f_type === 'Admin')).length }}
      attachment{{ filesArray.filter(f => groups.includes('admin') || !(f.file_type === 1 || f.f_type === 'Admin')).length !== 1 ? 's' : '' }}
      <span v-if="filesArray.filter(f => groups.includes('admin') || !(f.file_type === 1 || f.f_type === 'Admin')).length > 3" class="ml-2">(scroll for more)</span>
      <span v-if="checkingFiles && (loading || (expectedFiles > 0 && filesArray.length < expectedFiles))" class="ml-2">· Checking for files…</span>
    </div>

    <!-- 10 Oct 2025 JCH scrollable container to prevent vertical jumps -->
    <div class="attachments-scroll-box ml-5 mr-6">
      <draggable class="pt-0" v-model="filesArray" :disabled="readonlyType || effectiveNotUser"
                 style="min-height: 80px">
        <div v-for="file in filesArray" :key="file.loid">
        <!-- don't show admin files unless user is admin -->
        <v-row class="d-flex flex-row mt-n1 mb-n5" style="padding-left: 1vw; padding-right: 1vw"
               v-if="groups.includes('admin') || !(file.file_type === 1 || file.f_type === 'Admin')">
          <div v-if="!readonlyType && !effectiveNotUser" style="padding-left: 10px">
            <button-tip icon iname="mdi-trash-can-outline" tip="Remove attachment"
                        istyle="margin-top: 2px; color: #B22222" @click="disconnectFile(file)" :disabled="effectiveNotUser"
                        xsmall/>
          </div>
          <!-- 7 Aug 2026 JCH: NC-1620 — hide drag when read-only (same as trash); don't leave a disabled "Drag" control -->
          <button-tip v-if="!readonlyType && !effectiveNotUser" btnclass="mx-2" icolor="accent1" icon iname="mdi-menu"
                      istyle="margin-top: 3px" tip="Drag" xsmall/>
          <!-- 10 Oct 2025 JCH enable download only when loidfid present; re-render on loidfid change -->
          <button-tip
            :key="file.loid + '-' + (file.loidfid || 0)"
            :a="!!file.loidfid"
            :btnclass="(readonlyType || effectiveNotUser) ? 'ml-1' : ''"
            :disabled="effectiveNotUser || !file.loidfid"
            :href="file.loidfid ? `${url}/download/${file.loidfid}` : undefined"
            :loading="!!downloading[file.loidfid]"
            @click="startDownload(file)"
            icon
            iname="mdi-download"
            :istyle="(file.loidfid ? 'color: blue' : 'color: #9e9e9e') + '; margin-top: 2px'"
            :tip="downloading[file.loidfid]
              ? 'Downloading…'
              : (file.loidfid ? 'Download' : 'Linking… try the refresh icon')"
            xsmall
          />
          <span style="color: black; cursor: pointer; font-size: .85rem; margin-top: 3px; max-width: 65px;
            min-width: 65px; text-align: right">{{$_prettyBytes(file.size)}}</span>
          <v-text-field
              :disabled="readonlyType || (effectiveNotUser && !groups.includes('admin')) ||
                (!groups.includes('admin') && (file.file_type === 3 || file.f_type === 'Form'))"
              style="margin-top: -2px; margin-bottom: 2px; font-size: 14px"
              v-model="file.file_description" class="file pl-2 file-description-field" dense
              @input="!filesChanged.includes(file.loid) ? filesChanged.push(file.loid) : ''"
          ></v-text-field>
        </v-row>
      </div>
    </draggable>
      <div class="attachments-fade"></div>
    </div>

    <v-row class="pt-0 mx-auto mt-n3 justify-space-around selects-row"
           v-if="showAttachPickers">
      <v-col cols="12" sm="1" class="ml-2 mr-n2 upload-col"
             :class="$vuetify.breakpoint.xs ? 'mt-0 mb-1' : 'mt-3'"
             v-if="showFirmFileUploadColumn">
        <FirmFilesUpload v-bind="{ fid }" @filesUploaded="filesUploaded"/>
      </v-col>
      <v-col cols="12" :sm="showFirmFileUploadColumn ? 11 : 12">
        <v-row>
          <v-col v-if="type !== 'claim'" cols="12" sm="6">
            <!-- 10 Oct 2025 JCH scrollbox acts as autocomplete trigger -->
            <v-autocomplete :key="`forms-${type}-${typeId || 0}`" class="py-0 mx-2 forms-label" style="margin-bottom: 0"
                            dense
                            hide-details
                            @input="disconnectedLoids = disconnectedLoids.filter(loid => !attachedForms.some(f => f.loid === loid)),
                              filesArray = _.union(filesArray, attachedForms), filesArray = _.uniqBy(filesArray, 'loid'),
                              filesArray = filesArray.filter(f => !disconnectedLoids.includes(f.loid))"
                            :items="allForms"
                            item-text="file_description"
                            item-value="loid"
                            :loading="formsLoading"
                            :no-data-text="formsLoading ? 'Loading forms...' : 'No forms available'"
                            multiple
                            :disabled="!fid || formsLoading"
                            :readonly="readonlyType || effectiveNotUser"
                            return-object
                            v-model="attachedForms"
            >
              <template v-slot:label>
                Attach Form/s
                <v-tooltip bottom max-width="420">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small class="ml-1 info-icon" v-on="on" v-bind="attrs">mdi-information-outline</v-icon>
                  </template>
                  <div class="caption tooltip-help">
                    Selecting items adds them to the attachments above. To remove, click the
                    <v-icon small class="tooltip-trash mx-1">mdi-trash-can-outline</v-icon>
                    on a row. The select field and dropdown show only your recent picks; search to find others.
                  </div>
                </v-tooltip>
              </template>
              <template v-slot:selection="{ item, index, attrs, selected, select, on }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  :input-value="selected"
                  x-small
                  class="chip-tight"
                >
                  <span class="chip-label">{{ item.file_description }}</span>
                  <v-icon small class="ml-1" @click.stop="attachedForms = attachedForms.filter(f => f.loid !== item.loid)">mdi-close-circle</v-icon>
                </v-chip>
              </template>
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-bind="attrs" v-on="on" dense>
                  <v-list-item-action class="mr-2">
                    <v-checkbox :input-value="attrs.inputValue" :ripple="false" color="secondary" @click.stop="on.click($event)"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title :title="item.file_description">{{ item.file_description }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" :sm="type === 'claim' ? 12 : 6" id="resultId">
            <!-- 10 Oct 2025 JCH scrollbox acts as autocomplete trigger -->
            <v-autocomplete :key="`files-${type}-${typeId || 0}`" class="py-0 mx-2 files-label" style="margin-bottom: 0"
                            dense
                            hide-details
                            @input="disconnectedLoids = disconnectedLoids.filter(loid => !attachedFiles.some(f => f.loid === loid)),
                              filesArray = _.union(filesArray, attachedFiles), filesArray = _.uniqBy(filesArray, 'loid'),
                              filesArray = filesArray.filter(f => !disconnectedLoids.includes(f.loid))"
                            :items="firmFiles"
                            item-text="datefile"
                            item-value="loidfid"
                            :loading="firmFilesLoading"
                            :no-data-text="firmFilesLoading ? 'Loading files...' : 'No files available'"
                            multiple
                            :disabled="!fid || firmFilesLoading"
                            :readonly="readonlyType || effectiveNotUser"
                            return-object
                            v-model="attachedFiles"
            >
              <template v-slot:label>
                Attach File/s
                <v-tooltip bottom max-width="420">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small class="ml-1 info-icon" v-on="on" v-bind="attrs">mdi-information-outline</v-icon>
                  </template>
                  <div class="caption tooltip-help">
                    Selecting items adds them to the attachments above. To remove, click the
                    <v-icon small class="tooltip-trash mx-1">mdi-trash-can-outline</v-icon>
                    on a row. The select field and dropdown show only your recent picks; search to find others.
                  </div>
                </v-tooltip>
              </template>
              <template v-slot:selection="{ item, index, attrs, selected, select, on }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  :input-value="selected"
                  x-small
                  class="chip-tight"
                >
                  <span class="chip-label">{{ item.file_description || item.filename }}</span>
                  <v-icon small class="ml-1" @click.stop="attachedFiles = attachedFiles.filter(f => f.loidfid !== item.loidfid)">mdi-close-circle</v-icon>
                </v-chip>
              </template>
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-bind="attrs" v-on="on" dense>
                  <v-list-item-action class="mr-2">
                    <v-checkbox :input-value="attrs.inputValue" :ripple="false" color="secondary" @click.stop="on.click($event)"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title :title="item.datefile">{{ item.datefile }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </div>
</template>

<script>
  import draggable from 'vuedraggable';
  import FirmFilesUpload from "./FirmFilesUpload";
  import moment from 'moment';
  import { ClaimsAPIService } from '@/servicehandlers/ClaimsAPIService';
  import { FileobjectsAPIService } from '@/servicehandlers/FileobjectsAPIService';
  import { FirmsAPIService } from '@/servicehandlers/FirmsAPIService';
  import { NotesAPIService } from '@/servicehandlers/NotesAPIService';
  import { PoliciesAPIService } from "@/servicehandlers/PoliciesAPIService";

  const claimsAPIService = new ClaimsAPIService();
  const firmsAPIService = new FirmsAPIService();
  const file_objects = new FileobjectsAPIService();
  const notesAPIService = new NotesAPIService();
  const policiesAPIService = new PoliciesAPIService();

  export default {
    name: "EditFiles",
    components: { FirmFilesUpload, draggable },
    props: {
      fid: Number,
      groups: Array,
      type: String,
      typeId: Number,// this is note.nid, policy.pid, claim.clid, etc.
      notUser: {default: false},
      readonlyType: {default: false},
    },
    computed: {
      // 7 May 2026 JCH Notes use notUser when the record belongs to another staffer. Claims do not; route scope already gates edit.
      effectiveNotUser() {
        return this.type === 'claim' ? false : this.notUser;
      },
      // 7 May 2026 JCH Upload FAB column only when scope allows; picker uses sm 11 beside it or full 12 when no upload column.
      showFirmFileUploadColumn() {
        return !this.readonlyType && !this.effectiveNotUser && this.$_can('firmfile-upload');
      },
      // 7 Aug 2026 JCH: NC-1620 — hide attach/upload chrome when inbound/other-staff read-only; list stays mounted
      showAttachPickers() {
        return !this.readonlyType && !this.effectiveNotUser;
      },
    },
    data: () => ({
      allForms: [],
      attachedFiles: [],
      attachedForms: [],
      checkingFiles: false,// 2025-08-09 brief hint for all opens
      expectedFiles: 0,// 2025-08-09 read expected count from URL
      filesArray: [],
      filesChanged: [],
      filesToUpload: [],
      firmFilesLoading: false,
      firmFiles: [],
      formsLoading: false,
      initial: true,
      loading: true,
      _updateTimer: null,// 2025-08-12 timer for debounced updates
      uploadedFiles: [],
      url: process.env.VUE_APP_UW_URL,
      disconnectedLoids: [], // 10 Oct 2025 JCH track X-deleted loids so dropdowns don't re-add
      downloading: {}, // loidfid -> true while showing spinner
    }),

    watch: {

      filesArray() {// emit updated filesArray, and sync the attachment order for the current record type
        this.$emit('filesArrayUpdated', this.filesArray);
        if (this.initial === true) { this.initial = false; return; }
        if (!this.typeId) return; // 10 Oct 2025 JCH skip update if no typeId (record not loaded yet)
        if (this.checkingFiles && this.isLinking()) return; // 10 Oct 2025 JCH avoid PUT only while actively polling for copied files

        // minimal debounce to avoid burst server calls
        clearTimeout(this._updateTimer);
        this._updateTimer = setTimeout(async () => {
          if (!this.typeId) return; // 10 Oct 2025 JCH recheck typeId after debounce delay
          const loids = this.filesArray
            .map(a => a.loid)
            .filter(loid => /^\d+$/.test(String(loid))); // 10 Oct 2025 JCH send only real numeric loids (skip placeholders)
          try { // 10 Oct 2025 JCH catch network errors
            if (this.type === 'note') {
              await notesAPIService.updateFiles(this.typeId, loids, this.$router);
              // 10 Oct 2025 JCH poll for loidfid until all items have it
              this.pollForLoidfid();
            } else if (this.type === 'policy') {
              await policiesAPIService.updateFiles(this.typeId, loids, this.$router);
            } else if (this.type === 'claim') {
              await claimsAPIService.updateFiles(this.typeId, loids, this.$router);
            }
          } catch (e) {
            console.warn('EditFiles update failed:', e); // 10 Oct 2025 JCH log but don't crash
          }
        }, 400);
      },

      filesChanged() {// loop through filesChanged, find file_description for that loid, then update file
        if (!this.filesChanged.length) return;
        for (let loid of this.filesChanged) {
          // get file_description
          const file = { file_description: this.filesArray.find(x => x.loid === loid).file_description };
          file_objects.updateFileObject(loid, file, this.$router).then((response) => {
            this.filesChanged = [];// reset
          }).catch((error) => {
            console.debug('error: ', error);
          });
        }
      },
    },

    mounted() {
      this.initial = true;
      const exp = Number(this.$route?.query?.expectedFiles || 0); // 10 Oct 2025 JCH read expected count from URL
      this.expectedFiles = Number.isFinite(exp) && exp > 0 ? exp : 0; // 10 Oct 2025 JCH store if valid (>0)
      this._checkingDelayId = setTimeout(() => { this.checkingFiles = true }, 350);// 2025-08-09 hint on slow first fetch (avoid flicker)
      if (!this.filesArray.length && this.fid && this.typeId) this.getAllFiles(this.fid, this.typeId); // 2025-08-09 fetch if list empty
    },

    beforeDestroy() { this._isDestroyed = true; },// 2025-08-12 stop polling if unmounts

    methods: {
      startDownload(file) {
        if (!file || !file.loidfid) return;
        const id = String(file.loidfid);
        this.$set(this.downloading, id, true);
        // 31 Oct 2025 JCH auto-clear spinner after ~2s as a simple feedback
        setTimeout(() => { this.$delete(this.downloading, id); }, 2000);
      },


      isLinking() { // 10 Oct 2025 JCH pause updates while backend is still linking copied files
        return this.expectedFiles > 0 && this.filesArray.length < this.expectedFiles;
      },

      connectUploadedFiles() {
        for (let fle of this.uploadedFiles) {
          this.filesArray.push(fle);// this will trigger watch filesArray which will connect to the current record type
        }
        // if user chooses same file more than once, remove
        this.filesArray = this._.uniqBy(this.filesArray, 'loid');
      },

      disconnectFile(file) {
        // 31 Oct 2025 JCH remove from selects/chips by stable id (if present), then from filesArray
        const loid = file && file.loid;
        const loidfid = file && file.loidfid;
        if (Array.isArray(this.attachedForms) && loid) {
          this.attachedForms = this.attachedForms.filter(f => f && f.loid !== loid);
        }
        if (Array.isArray(this.attachedFiles)) {
          this.attachedFiles = this.attachedFiles.filter(f => !(f && ((f.loid && loid && f.loid === loid) || (f.loidfid && loidfid && f.loidfid === loidfid))));
        }
        if (Array.isArray(this.filesArray)) {
          this.filesArray = this.filesArray.filter(f => !(f && ((f.loid && loid && f.loid === loid) || f === file)));
        }
        if (loid && !this.disconnectedLoids.includes(loid)) this.disconnectedLoids.push(loid); // prevent dropdown re-add
        this.scroll();// scrolls back to bottom
      },

      filesUploaded(files) {
        this.uploadedFiles = files;
        this.connectUploadedFiles();
        if (this.fid) this.getFirmFiles(this.fid); // 8 May 2026 JCH uploaded files change the firm's available-file list
      },

      getAllFiles(fid, id) {
        const firmId = fid || this.fid; // can be briefly null before parent prop updates
        if (firmId) this.getFirmFiles(firmId);
        this.loading = true;
        if (this.type === 'policy') {
          policiesAPIService.getPolicyFiles(id, this.$router).then((files) => {
            this.filesArray = files;
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false;
              if (this._checkingDelayId) { clearTimeout(this._checkingDelayId); this._checkingDelayId = null; }
              if (this.expectedFiles === 0) this.checkingFiles = false;
            });
        }
        if (this.type === 'claim') {
          claimsAPIService.getClaimFiles(id, this.$router).then((files) => {
            this.filesArray = files || [];
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false;
              if (this._checkingDelayId) { clearTimeout(this._checkingDelayId); this._checkingDelayId = null; }
              if (this.expectedFiles === 0) this.checkingFiles = false;
            });
        }
        if (this.type === 'note') {
          notesAPIService.getNoteFiles(id, this.$router).then((files) => {
            this.filesArray = files;
            for (let file of this.filesArray) {
              if (!file.file_description) {
                file.file_description = file.filename;
                this.filesChanged.push(file.loid);
              }
            }
          })
          .then(() => { // 2025-08-09 short poll until total files == expected
            if (this.expectedFiles > 0 && this.filesArray.length < this.expectedFiles) {
              this.checkingFiles = true; // show spinner immediately while starting poll
              this.pollFilesUntilExpected(id);
            } else {
              this.checkingFiles = false; // avoid indefinite linking if counts already match
            }
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
            if (this._checkingDelayId) { clearTimeout(this._checkingDelayId); this._checkingDelayId = null; }
            if (this.expectedFiles === 0) this.checkingFiles = false;
          });
        }
        if (firmId && this.type !== 'claim') {
          this.formsLoading = true;
          file_objects.getAllForms(firmId, this.$router).then((forms) => {
            if (!!forms) this.allForms = forms;
          }).catch(() => {})
            .finally(() => {
              this.formsLoading = false;
            });
        } else if (this.type === 'claim') {
          this.allForms = [];
          this.attachedForms = [];
          this.formsLoading = false;
        }
      },

      getFirmFiles(fid) {
        if (!fid) return;
        this.firmFilesLoading = true;
        firmsAPIService.getFirmFiles(fid, null, null, this.$router).then((data) => {
          // 20 Feb 2026 JCH: normalize API shape (array vs paged { result }) to prevent reduce/type errors.
          const rows = Array.isArray(data) ? data : (Array.isArray(data?.result) ? data.result : []);
          if (rows.length) {
            this.firmFiles = rows.reduce((files, file) => {
              if (file.file_type_description === 'Admin' && !this.groups.includes('admin')) return files;
              file.formattedDate = moment(file.dated,
                  'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD MMM YYYY hh:mm A');
              file.datefile = `${file.formattedDate}\xa0\xa0\xa0${file.file_description}`;
              files.push(file);
              return files;
            }, []);
          } else {
            this.firmFiles = [];
          }
        }).catch((error) => {
          console.warn('getFirmFiles failed:', error);
          this.firmFiles = []; // Clear on error to prevent stale data
        }).finally(() => {
          this.firmFilesLoading = false;
        });
      },

      scroll() {
        this.$nextTick(() => window.scrollTo(0,document.body.scrollHeight));
      },

      async pollFilesUntilExpected(id) {
        const stopAt = Date.now() + 12000; // hard stop ~12s
        const hideAt = Date.now() + 5000;  // hide text after 5s
        let delayMs = 250;
        this.checkingFiles = true;
        while (this.filesArray.length < this.expectedFiles && Date.now() < stopAt && !this._isDestroyed) {
          try {
            const next = await notesAPIService.getNoteFiles(id, this.$router);
            this.filesArray = next || [];
          } catch (e) {
            // ignore transient 404/Bad Request while backend is still linking; keep polling
          }
          if (Date.now() > hideAt) this.checkingFiles = false; // keep polling silently
          await new Promise(r => setTimeout(r, delayMs));
          delayMs = Math.min(delayMs + 150, 1000);
        }
        this.checkingFiles = false;
      },

      async pollForLoidfid() { // 10 Oct 2025 JCH poll until all items have loidfid
        for (let i = 0; i < 10 && !this._isDestroyed; i++) { // 10 Oct 2025 JCH max 10 attempts over ~7s
          if (!this.filesArray.some(f => f.loid && !f.loidfid)) break; // 10 Oct 2025 JCH stop when all have loidfid
          await new Promise(r => setTimeout(r, 700)); // 10 Oct 2025 JCH check every 0.7s
          if (!this.typeId) break;
          try {
            const refreshed = await notesAPIService.getNoteFiles(this.typeId, this.$router);
            refreshed?.forEach(nf => { const ex = this.filesArray.find(f => f.loid === nf.loid); if (ex && !ex.loidfid && nf.loidfid) ex.loidfid = nf.loidfid; });
          } catch (e) {} // 10 Oct 2025 JCH ignore errors
        }
      },

    },
  }
</script>

<style scoped>
/* 10 Oct 2025 JCH scrollable attachments container with visual cues */
.attachments-scroll-box {
  max-height: 117px; /* was 107px */
  min-height: 117px; /* was 107px */
  overflow-y: auto;
  overflow-x: hidden; /* 10 Oct 2025 JCH prevent horizontal scroll */
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: white;
  margin-bottom: 20px; /* 10 Oct 2025 JCH default spacing under attachments */
  padding-top: 0; /* 10 Oct 2025 JCH tighter top */
  padding-bottom: 0; /* 10 Oct 2025 JCH remove extra bottom padding */
}

/* 10 Oct 2025 JCH gradient fade at bottom hints more content below */
.attachments-fade{
  position: sticky;
  bottom: 0;
  height: 32px;
  background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0.85) 70%, #fff 100%);
  pointer-events: none;
  z-index: 1;
}

/* 10 Oct 2025 JCH fixed height for chip selections to prevent jumping */
.v-select.v-input--dense >>> .v-select__selections {
  min-height: 44px !important;
  max-height: 44px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  align-items: flex-start !important; /* 10 Oct 2025 JCH top-align chips to avoid varying vertical gap */
  padding-top: 1px !important; /* 10 Oct 2025 JCH consistent top padding */
  padding-bottom: 0 !important; /* 10 Oct 2025 JCH remove bottom padding */
}

/* 10 Oct 2025 JCH tighter chip spacing */
.chip-tight {
  margin: 1px 3px !important;
  padding: 0 6px !important;
  font-size: 12px !important;
}
/* chip text ellipsis without hiding the close button */
.chip-label{display:inline-block;max-width:calc(100% - 18px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}

/* 10 Oct 2025 JCH reduce Vuetify select bottom gutter just inside this component */
.selects-row >>> .v-input__slot { margin-bottom: 0 !important; }
.selects-row >>> .v-input__control { padding-bottom: 0 !important; }
.selects-row >>> .v-text-field__details { display: none !important; }

/* 10 Oct 2025 JCH no-wrap rows across all widths */
.attachments-scroll-box >>> .v-row{flex-wrap:nowrap!important}
.attachments-scroll-box >>> .v-row .v-text-field{flex:1 1 0%!important;min-width:0!important}
/* removed duplicate flex rule; generic .v-input rule below suffices */
.attachments-scroll-box >>> .v-text-field__slot{white-space:nowrap!important;overflow-x:auto!important;padding-right:4px!important}

/* 10 Oct 2025 JCH minimal rules per request */
.attachments-scroll-box >>> .v-input{width:auto!important;flex:1 1 0%!important;min-width:0!important}

/* 31 Oct 2025 JCH minimal mobile chip/spacing tweaks */
@media (max-width:600px){
  .attachments-scroll-box{margin-bottom:12px!important;max-height:96px!important;min-height:96px!important}
  .v-select.v-input--dense >>> .v-chip__content{overflow:visible!important}
  .v-select.v-input--dense >>> .v-chip__content .chip-label{max-width:calc(100% - 18px)}
  /* tighten chip row height and font for selects */
  .v-select.v-input--dense >>> .v-select__selections{min-height:36px!important;max-height:36px!important;padding-top:0!important}
  /* slightly smaller attachment row font */
  .attachments-scroll-box >>> .v-input{font-size:12px!important}
  /* ensure full end-of-line visibility and smooth horizontal scroll */
  .attachments-scroll-box >>> .v-text-field__slot{padding-right:14px!important;-webkit-overflow-scrolling:touch}
  /* smaller + FAB and tighter spacing */
  .upload-col{margin-top:-8px!important;margin-bottom:18px!important;padding-top:0!important;padding-bottom:0!important}
  .upload-col >>> .v-tooltip{margin-top:0!important;margin-bottom:0!important;padding-top:0!important;padding-bottom:0!important}
}

/* 31 Oct 2025 JCH mobile tweaks to prevent overlap between + button and label */
@media (max-width: 600px) { .selects-row { margin-top: -2px !important; } }

/* show inline icon in label by disabling ellipsis on that label */
.forms-label >>> .v-label{overflow:visible!important;text-overflow:unset!important;white-space:nowrap!important}
.forms-label >>> .info-icon{font-size:18px!important;cursor:pointer;opacity:.95;vertical-align:middle;pointer-events:auto;position:relative;z-index:2;top:-1px}
/* same treatment for files label */
.files-label >>> .v-label{overflow:visible!important;text-overflow:unset!important;white-space:nowrap!important}
.files-label >>> .info-icon{font-size:18px!important;cursor:pointer;opacity:.95;vertical-align:middle;pointer-events:auto;position:relative;z-index:2;top:-1px}
/* tooltip content as a single block/column */
.tooltip-help{display:block;white-space:normal}
/* make trash icon in tooltip easier to see */
.tooltip-trash{color:#B22222;background:#fff;border-radius:50%;padding:2px;font-size:18px!important;vertical-align:middle;box-shadow:0 0 0 1px rgba(0,0,0,.08)}
</style>
